import { withSvgIcon } from './withSvgIcon';

export const Briefcase = withSvgIcon(
  <>
    <path
      d="M3.5 9C3.5 7.89543 4.39543 7 5.5 7H14.5C15.6046 7 16.5 7.89543 16.5 9V14.5C16.5 15.6046 15.6046 16.5 14.5 16.5H5.5C4.39543 16.5 3.5 15.6046 3.5 14.5V9Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M3 11L17 11" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M13.5 7V5.5C13.5 4.39543 12.6046 3.5 11.5 3.5H8.5C7.39543 3.5 6.5 4.39543 6.5 5.5V7"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M10 9.5V12.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </>,
  { viewBox: '0 0 20 20' },
);
